import {
    AUTH_ERROR,
    AUTHENTICATED_USER,
    SET_PERMISSIONS,
    UNAUTHENTICATED_USER
} from "./types";

const INITIAL_STATE = {
    error: false,
    authenticated: false,
    permissions: {},
    user: {},
};

export default function(state = INITIAL_STATE, action) {

    switch(action.type) {
        case AUTHENTICATED_USER:
        return {
                ...state,
                authenticated: true,
                error: false,
                user: action.payload,
            };

        case UNAUTHENTICATED_USER:
            return {
                ...state,
                authenticated: false,
            };

        case AUTH_ERROR:
            return {
                ...state,
                error: action.payload.error
            };

        case SET_PERMISSIONS:
            return {
                ...state,
                permissions: action.payload
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/containers/auth/reducer.js